import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

interface GroupData {
  id: string;
  name: string;
}

interface MarkdownData {
  id: string;
  title: string;
  content: string;
  groupId: string;
}

const MarkdownList: React.FC = () => {
  const [markdownList, setMarkdownList] = useState<MarkdownData[]>([]);
  const [groupList, setGroupList] = useState<GroupData[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = () => {
    const savedMarkdown = localStorage.getItem('markdown-list');
    const savedGroup = localStorage.getItem('group-list');
    if (savedMarkdown) {
      setMarkdownList(JSON.parse(savedMarkdown));
    }
    if (savedGroup) {
      setGroupList(JSON.parse(savedGroup));
    }
  };

  const getGroupName = (groupId: string) => {
    const group = groupList.find((g) => g.id === groupId);
    return group ? group.name : '不明';
  };

  const handleDelete = (id: string) => {
    if (!window.confirm('本当に削除しますか？')) return;
    const updatedList = markdownList.filter((doc) => doc.id !== id);
    localStorage.setItem('markdown-list', JSON.stringify(updatedList));
    setMarkdownList(updatedList);
  };

  const columns: GridColDef[] = [
    { field: 'title', headerName: 'タイトル', flex: 1 },
    { field: 'groupName', headerName: 'グループ', flex: 1 },
    {
      field: 'actions',
      headerName: '操作',
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => handleDelete(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
      width: 100,
    },
  ];

  const rows = markdownList.map((doc) => ({
    id: doc.id,
    title: doc.title,
    groupName: getGroupName(doc.groupId),
  }));

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" component="h1">
            保存済みMarkdown一覧
          </Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/admin/new')}>
            新規作成
          </Button>
        </Box>

        {markdownList.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10]}
            onRowClick={(params) => navigate(`/admin/edit/${params.id}`)}
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            まだMarkdownは保存されていません。
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default MarkdownList;
